import { gql, useQuery } from "@apollo/client";
import { useHistory } from "react-router-dom";
import React, { useState } from "react";
import { BreadCrumb, BreadCrumbProp } from "../../components/light/Breadcrumb";
import { Content } from "../../components/light/Content";

const BreadCrumbItems: BreadCrumbProp[] = [
  { text: "applications", to: "#" },
  { text: "Tracking Code", to: "/" },
];

const QUERY = gql`
  query shipmentTrackingCodeList($offset: Int = 0, $limit: Int = 10) {
    shipmentTrackingCodeList(offset: $offset, limit: $limit) {
      trackingCode
      total
      from
      end
      success
      fail
    }
  }
`;

function TrackingCodeForm({ value, setValue, onEnter }: { value: string; setValue: any; onEnter: any }) {
  const [safe, setSafe] = useState(true);
  return (
    <div className="row">
      <div className="col-md-12">
        <form onSubmit={(e) => e.preventDefault()}>
          <div className={`input-group mb-3 ${!safe ? "has-error has-danger" : ""}`}>
            <input
              autoFocus={true}
              type="text"
              className="form-control"
              placeholder="Enter your tracking code here"
              value={value}
              onChange={(e) => {
                setValue(e.target.value.trim());
              }}
              onKeyDown={(e) => {
                if (e.keyCode === 13) {
                  setSafe(value ? true : false);
                  if (value) {
                    onEnter();
                  }
                }
              }}
            />
            <div className="input-group-prepend">
              <button
                className="input-group-text btn btn-primary btn-sm"
                style={{ borderRadius: "0 4px 4px 0", borderLeftWidth: 0 }}
                onClick={() => {
                  setSafe(value ? true : false);
                  if (value) {
                    onEnter();
                  }
                }}
                type="button"
              >
                Enter
              </button>
            </div>
          </div>
          {!safe && (
            <small className="help-block form-text with-errors form-control-feedback">
              Your tracking code is invalid
            </small>
          )}
        </form>
      </div>
    </div>
  );
}

export function TrackingCodeShipperScreen() {
  const { push } = useHistory();
  const [tracking_code, setTrackingCode] = useState("");
  const { data, loading } = useQuery(QUERY, {
    variables: {
      offset: 0,
      limit: 10000,
    },
    fetchPolicy: "no-cache",
  });

  if (loading || data === undefined) {
    return (
      <Content breadcrumb={<BreadCrumb items={BreadCrumbItems} />}>
        <div className="row">
          <div className="col-md-6">
            <TrackingCodeForm setValue={setTrackingCode} value={tracking_code} onEnter={() => {}} />
          </div>
        </div>
      </Content>
    );
  }

  return (
    <Content breadcrumb={<BreadCrumb items={BreadCrumbItems} />}>
      <div className="row">
        <div className="col-md-4">
          <TrackingCodeForm
            setValue={setTrackingCode}
            value={tracking_code}
            onEnter={() => {
              push("/tracking/" + tracking_code);
            }}
          />
          <br />
          {/* <div className="element-wrapper">
            <div className="element-header">Recent Activity</div>
            <div className="element-box-tp">
              <div className="activity-boxes-w">
                {data.shipmentTrackingCodeList.map((x: any, i: number) => {
                  return (
                    <div className="activity-box-w" key={i}>
                      <div className="activity-time">{x.end}</div>
                      <Link className="activity-box" to={`/tracking/${x.trackingCode}`}>
                        <div
                          className="activity-avatar"
                          style={{
                            display: "inline-flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <span className="os-icon os-icon-package" style={{ fontSize: 25 }}></span>
                        </div>
                        <div className="activity-info">
                          <div className="activity-role">{x.trackingCode}</div>
                          <strong className="activity-title">Recent Tracking Created On {x.from}</strong>
                        </div>
                      </Link>
                    </div>
                  );
                })}
              </div>
            </div>
          </div> */}
        </div>
      </div>
    </Content>
  );
}
